import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Paper-view-detail.svg'
import _imports_1 from '@/assets/icons/Paper-view-detail-gray.svg'


const _withScopeId = n => (_pushScopeId("data-v-7f998b15"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = {
  key: 1,
  class: "asahi-information-container"
}
const _hoisted_3 = { class: "text-white fw-bold" }
const _hoisted_4 = {
  key: 1,
  class: "delivery-date-wrapper"
}
const _hoisted_5 = { class: "d-flex flex-column mb-0 me-4 w-85" }
const _hoisted_6 = { class: "d-flex mb-0 align-items-center gap-2 mr-20" }
const _hoisted_7 = {
  key: 2,
  class: "asahi-mobile-information-container asahi-order-information-accordion w-100 fw-medium f-14"
}
const _hoisted_8 = {
  class: "accordion w-100",
  id: "asahi-order-information-accordion"
}
const _hoisted_9 = { class: "accordion-item" }
const _hoisted_10 = { class: "accordion-header w-100 d-flex align-items-center" }
const _hoisted_11 = { class: "row align-items-center header-row" }
const _hoisted_12 = {
  key: 0,
  class: "col-11"
}
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { class: "text-white" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = { class: "col-1" }
const _hoisted_17 = {
  id: 'asahi-order-information-accordion-collapse-' + 0,
  class: "accordion-collapse collapse w-100"
}
const _hoisted_18 = { class: "accordion-body pt-1" }
const _hoisted_19 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-12 d-flex w-fill align-items-center justify-content-start w-150 p-0" }
const _hoisted_22 = {
  key: 0,
  class: "row"
}
const _hoisted_23 = { class: "col-lg-12 d-flex w-fill align-items-center justify-content-start w-150 p-0" }
const _hoisted_24 = {
  key: 1,
  class: "row"
}
const _hoisted_25 = { class: "col-lg-12 d-flex w-fill align-items-center justify-content-start w-150 p-0" }
const _hoisted_26 = { class: "row justify-content-center" }
const _hoisted_27 = { class: "d-flex flex-column mb-0 me-4 w-85" }
const _hoisted_28 = { class: "d-flex mb-0 align-items-center gap-2 mr-20" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = { class: "col-12 d-flex justify-content-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!
  const _component_AsahiSelectHeader = _resolveComponent("AsahiSelectHeader")!
  const _component_DeliveryDatePicker = _resolveComponent("DeliveryDatePicker")!
  const _component_AsahiProgressBar = _resolveComponent("AsahiProgressBar")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiDiscountMessage = _resolveComponent("AsahiDiscountMessage")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoaderSpinner)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobile && !_ctx.isMoreSection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('Your delivery preferences:')), 1),
          _createVNode(_component_AsahiSelectHeader, {
            modelValue: _ctx.selectedShipmentId,
            options: _ctx.shipToOptions,
            "onUpdate:modelValue": _ctx.changeShipTo,
            icon: _ctx.shipToIcon,
            placeholder: _ctx.shipToOptions[0]?.label,
            isTicket: false,
            "is-white": true,
            "no-offset": true,
            isDatePickerOpen: _ctx.isDatePickerOpen
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen"]),
          (!_ctx.isOnTradeCustomer)
            ? (_openBlock(), _createBlock(_component_AsahiSelectHeader, {
                key: 0,
                modelValue: _ctx.selectedOrderType,
                options: _ctx.transportOptionsAsSelectBoxOptions,
                "onUpdate:modelValue": _ctx.changeDeliveryType,
                icon: _ctx.trackIcon,
                placeholder: _ctx.$t('Shipping Method'),
                isTicket: false,
                "is-white": true,
                isDatePickerOpen: _ctx.isDatePickerOpen
              }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen"]))
            : _createCommentVNode("", true),
          (!_ctx.isOnTradeCustomer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!_ctx.isOnTradeCustomer)
                  ? (_openBlock(), _createBlock(_component_DeliveryDatePicker, {
                      key: 0,
                      shipToId: _ctx.selectedShipmentId,
                      ref: "deliveryDatePickerRef",
                      modelValue: _ctx.deliveryDateSelected,
                      shipmentId: _ctx.selectedOrderType,
                      placeholder: _ctx.$t('Delivery date'),
                      holidayDays: _ctx.holidaysConfig,
                      "onUpdate:modelValue": _ctx.onDateSelection,
                      onOpen: _ctx.handleDatePickerOpen,
                      onClose: _ctx.handleDatePickerClose
                    }, null, 8, ["shipToId", "modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue", "onOpen", "onClose"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isOnTradeCustomer)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["bottle-container", _ctx.messageColorClass?.borderColor])
              }, [
                _createVNode(_component_AsahiProgressBar, {
                  percentage: _ctx.cashFilledPercentage,
                  error: _ctx.errorWeight,
                  success: _ctx.successWeight
                }, null, 8, ["percentage", "error", "success"])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.isFreeBeerCheckActive && !_ctx.isOnTradeCustomer && !_ctx.isQuickOrderPage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass(["pln-container d-inline-flex rounded-2 align-items-center gap-3", { 'pln-has-product': _ctx.isAllProductAdded, 'green-border' : _ctx.productFreeBeer.length > 0, 'gray-border' : _ctx.productFreeBeer.length === 0}])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_AsahiTypography, {
                    type: "body-2-bold",
                    class: _normalizeClass({ "primary-light-green-text" : _ctx.productFreeBeer.length > 0, "gray" : _ctx.productFreeBeer.length === 0})
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('1PLN')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_AsahiTypography, {
                    type: "subtitle-3",
                    class: _normalizeClass({ "primary-light-green-text" : _ctx.productFreeBeer.length > 0, "gray" : _ctx.productFreeBeer.length === 0})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.productFreeBeer.length), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.productFreeBeer.length === 1 ? 'record' : 'records')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.productFreeBeer.length > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "paper-img",
                        src: _imports_0,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPlnModal && _ctx.showPlnModal(...args)))
                      }))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "paper-img",
                        src: _imports_1,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPlnModal && _ctx.showPlnModal(...args)))
                      }))
                ])
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_AsahiDiscountMessage)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.isExpanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Ship to') + ' '), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentShippingPlace?.label) + " " + _toDisplayString(_ctx.isOnTradeCustomer ? '' :( '-' + _ctx.currentShippingMethod?.label)) + " " + _toDisplayString(_ctx.isOnTradeCustomer ? '' : ('-' + _ctx.formattedDeliveryDate)), 1),
                        (!_ctx.isOnTradeCustomer)
                          ? (_openBlock(), _createBlock(_component_AsahiProgressBar, {
                              key: 0,
                              percentage: _ctx.cashFilledPercentage,
                              error: _ctx.errorWeight,
                              success: _ctx.successWeight,
                              "message-type": "icon-only"
                            }, null, 8, ["percentage", "error", "success"]))
                          : _createCommentVNode("", true),
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isExpanded)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["text-white fw-bold px-0", _ctx.isOnTradeCustomer ? 'col-11' : 'col-4' ])
                      }, _toDisplayString(_ctx.$t('Order details')), 3))
                    : _createCommentVNode("", true),
                  (!_ctx.isExpanded && !_ctx.isOnTradeCustomer)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["bottle-container col-7", _ctx.messageColorClass?.borderColor])
                      }, [
                        _createVNode(_component_AsahiProgressBar, {
                          "is-white": true,
                          percentage: _ctx.cashFilledPercentage,
                          error: _ctx.errorWeight,
                          success: _ctx.successWeight,
                          "message-type": "mobile"
                        }, null, 8, ["percentage", "error", "success"])
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      class: "accordion-button collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": '#asahi-order-information-accordion-collapse-' + 0,
                      "aria-expanded": "false",
                      "aria-controls": 'asahi-order-information-accordion-collapse-' + 0,
                      onClick: _cache[2] || (_cache[2] = (event) => _ctx.toggleAccordion(event, 0))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_AsahiSelectHeader, {
                          modelValue: _ctx.selectedShipmentId,
                          options: _ctx.shipToOptions,
                          "onUpdate:modelValue": _ctx.changeShipTo,
                          icon: _ctx.shipToIcon,
                          placeholder: _ctx.shipToOptions[0]?.label,
                          "is-white": true,
                          "no-offset": true,
                          "is-mobile": true,
                          "selected-modal": true,
                          title: _ctx.$t('Ship to'),
                          "sticky-bar": true
                        }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title"])
                      ])
                    ]),
                    (!_ctx.isOnTradeCustomer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_AsahiSelectHeader, {
                              modelValue: _ctx.selectedOrderType,
                              options: _ctx.transportOptionsAsSelectBoxOptions,
                              "onUpdate:modelValue": _ctx.changeDeliveryType,
                              icon: _ctx.trackIcon,
                              placeholder: _ctx.$t('Shipping Method'),
                              "is-white": true,
                              "is-mobile": true,
                              "selected-modal": false,
                              title: _ctx.$t('Type of Transport'),
                              "sticky-bar": true
                            }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isOnTradeCustomer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_DeliveryDatePicker, {
                              shipToId: _ctx.selectedShipmentId,
                              ref: "deliveryDatePickerRefMob",
                              modelValue: _ctx.deliveryDateSelected,
                              shipmentId: _ctx.selectedOrderType,
                              placeholder: _ctx.$t('Delivery date'),
                              holidayDays: _ctx.holidaysConfig,
                              "onUpdate:modelValue": _ctx.onDateSelection,
                              "is-mobile": true
                            }, null, 8, ["shipToId", "modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      (_ctx.isFreeBeerCheckActive && !_ctx.isOnTradeCustomer)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["pln-container d-inline-flex rounded-2 align-items-center gap-3 col-12", { 'pln-has-product': _ctx.isAllProductAdded, 'green-border' : _ctx.productFreeBeer.length > 0, 'gray-border' : _ctx.productFreeBeer.length === 0}])
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_AsahiTypography, {
                                type: "body-2-bold",
                                class: _normalizeClass({ "primary-light-green-text" : _ctx.productFreeBeer.length > 0, "gray" : _ctx.productFreeBeer.length === 0})
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('1PLN')), 1)
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_AsahiTypography, {
                                type: "subtitle-3",
                                class: _normalizeClass({ "primary-light-green-text" : _ctx.productFreeBeer.length > 0, "gray" : _ctx.productFreeBeer.length === 0})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.productFreeBeer.length), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.productFreeBeer.length === 1 ? 'record' : 'records')), 1)
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _createElementVNode("div", null, [
                              (_ctx.productFreeBeer.length > 0)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "paper-img",
                                    src: _imports_0,
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showPlnModal && _ctx.showPlnModal(...args)))
                                  }))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "paper-img",
                                    src: _imports_1,
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showPlnModal && _ctx.showPlnModal(...args)))
                                  }))
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_AsahiDiscountMessage)
                      ])
                    ])
                  ]),
                  (!_ctx.isOnTradeCustomer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_AsahiProgressBar, {
                            "is-white": true,
                            percentage: _ctx.cashFilledPercentage,
                            error: _ctx.errorWeight,
                            success: _ctx.successWeight,
                            "message-type": "mobile-long"
                          }, null, 8, ["percentage", "error", "success"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
  ]))
}